import toast from 'react-hot-toast';
import {
    SET_CHANNELS,
    SET_ALL_CHANNELS,
    UPDATE_CHANNEL,
    SET_ARCHIVE_FILTER,
    SET_SHOW_UNLINKED_COUNT,
    SET_CHANNEL_PANEL_OPEN,
    SET_FULLSCREEN_IMAGE,
    SET_CHANNELS_LOADING,
    SET_ACTIVE_THREAD_PARENT_ID
} from '../constants/channel.constant';
import * as channelService from '../../services/channel.service';

// ============ Simple Actions ============

export const setChannels = (channels) => ({
    type: SET_CHANNELS,
    payload: channels
});

export const setAllChannels = (channels) => ({
    type: SET_ALL_CHANNELS,
    payload: channels
});

export const updateChannel = (channelId, updates) => ({
    type: UPDATE_CHANNEL,
    payload: { channelId, updates }
});

export const setArchiveFilter = (filter) => ({
    type: SET_ARCHIVE_FILTER,
    payload: filter
});

export const setShowUnlinkedCount = (show) => ({
    type: SET_SHOW_UNLINKED_COUNT,
    payload: show
});

export const setChannelPanelOpen = (isOpen) => ({
    type: SET_CHANNEL_PANEL_OPEN,
    payload: isOpen
});

export const setFullscreenImage = (imageUrl) => ({
    type: SET_FULLSCREEN_IMAGE,
    payload: imageUrl
});

export const setActiveThreadParentId = (messageId) => ({
    type: SET_ACTIVE_THREAD_PARENT_ID,
    payload: messageId
});

// ============ Thunk Actions ============

/**
 * Fetch all channels from API
 * Sorts user's own personalized channel first by default
 */
export const fetchChannels = () => async (dispatch) => {
    dispatch({ type: SET_CHANNELS_LOADING, payload: true });

    try {
        const channels = await channelService.fetchChannels({ sortOwnFirst: true });
        dispatch(setAllChannels(channels));
    } catch (error) {
        const message = error?.response?.data?.message || 'Error fetching channels';
        toast.error(message);
        console.error('Error fetching channels:', error);
    } finally {
        dispatch({ type: SET_CHANNELS_LOADING, payload: false });
    }
};

/**
 * Update last viewed channel on backend
 */
export const saveLastViewedChannel = (channelId) => async () => {
    try {
        await channelService.updateLastViewedChannel(channelId);
    } catch (error) {
        console.log('Failed to save last viewed channel:', error);
    }
};

/**
 * Toggle unlinked count visibility (persists to localStorage)
 */
export const toggleUnlinkedCount = (show) => (dispatch) => {
    localStorage.setItem('showUnlinkedCount', JSON.stringify(show));
    dispatch(setShowUnlinkedCount(show));
};
